import classNames from "classnames";
import BootDatePicker from "components/common/custom/forms/BootDatePicker";
import TextInput from "components/common/custom/forms/BootTextField/TextField";
import MultiSelect from "components/common/MultiSelect";
import { nationalityData } from "features/practitioner/utils";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ViewEmpolyee } from "../config/empolyeeApi";
import { GetAllDropDownData } from "features/eliglibility/eliglibility-check/config/eligibilityCheckApi";
import { GetAllBranchesData } from "features/branch/config/branchApi";
const isEnglish = (value) => /^[A-Za-z0-9\s'-]+$/.test(value);
const isArabic = (value) => /^[\u0600-\u06FF\s]+$/.test(value);
const AddEmpolyeeForm = ({
  control,
  watch,
  setValue,
  errors,
  clearErrors,
  view,
  isSubmitted,
}) => {
  const dispatch = useDispatch();
  const { empolyeeSingleData, systemPrivillageList } = useSelector(
    (state) => state.empolyee
  );

  const { allBranchesData } = useSelector((state) => state.branch);

  const allBranches = JSON.parse(localStorage.getItem("branch_settings")) || [];
  // const isValidDate = (value) => /^\d{4}-\d{2}-\d{2}$/.test(value);
  const { id } = useParams();
  const emailValue = watch("email");
  const usernameValue = watch("username");

  // Sync email and username fields
  useEffect(() => {
    if (id) {
      if (emailValue !== usernameValue) {
        setValue("username", emailValue);
      }
    }
  }, [emailValue, id]);

  useEffect(() => {
    if (id) {
      if (usernameValue !== emailValue) {
        setValue("email", usernameValue);
      }
    }
  }, [usernameValue, id]);
  useEffect(() => {
    if (!id) return;
    dispatch(ViewEmpolyee(id));
  }, [id]);

  useEffect(() => {
    if (systemPrivillageList?.length === 0) {
      dispatch(GetAllDropDownData());
    }

    if (allBranchesData?.length === 0) {
      dispatch(GetAllBranchesData());
    }
  }, []);

  console.log({ allBranchesData });

  useEffect(() => {
    if (id) {
      const selectedBranches = empolyeeSingleData?.branch_id
        ?.split(",")
        .map((id) => parseInt(id.trim(), 10))
        .map((branchId) => {
          const branch = allBranchesData.find((b) => b.branch_id === branchId);
          return branch
            ? {
                value: branch.branch_id,
                label: branch.branch_name,
                cchi: branch.branch_cchino,
              }
            : null;
        })
        .filter(Boolean);
      setValue("empolyee_id", empolyeeSingleData?.employees_id);
      setValue("first_name_eng", empolyeeSingleData?.employees_firstname);
      setValue("father_name_eng", empolyeeSingleData?.employees_fathername);
      setValue("family_name_eng", empolyeeSingleData?.employees_familyname);
      setValue(
        "first_name_arabic",
        empolyeeSingleData?.employees_firstname_arabic
      );
      setValue(
        "father_name_arabic",
        empolyeeSingleData?.employees_fathername_arabic
      );
      setValue(
        "family_name_arabic",
        empolyeeSingleData?.employees_familyname_arabic
      );
      setValue("email", empolyeeSingleData?.employees_emailid);
      setValue("username", empolyeeSingleData?.employees_emailid);
      setValue(
        "nationality",
        nationalityData?.find(
          (item) =>
            item?.value === empolyeeSingleData?.employees_nationality ||
            item?.title === empolyeeSingleData?.nationality
        )
      );

      setValue("branch", selectedBranches);

      setValue("mobile_no", empolyeeSingleData?.employees_mobilenumber);
      setValue("national_id", empolyeeSingleData?.employees_nationalid);
      setValue("birth_date", empolyeeSingleData?.employees_dob || "");

      setValue(
        "system_privilage",
        systemPrivillageList?.find(
          (item) =>
            item?.syspri_id === empolyeeSingleData?.syspri_id ||
            item?.syspri_name === empolyeeSingleData?.rolename
        )
      );
    }
  }, [id, empolyeeSingleData]);

  return (
    <Row>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="first_name_eng"
          control={control}
          placeholder="First Name (English)"
          label="First Name (English)"
          errors={errors}
          disabled={view}
          required={true}
          size="sm"
          rules={{
            required: true,
            validate: (v) => isEnglish(v) || "Must be English letters only",
          }}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="father_name_eng"
          label="Father Name (English)"
          placeholder="Father Name (English)"
          control={control}
          errors={errors}
          disabled={view}
          required={false}
          size="sm"
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="family_name_eng"
          label="Family Name (English)"
          placeholder="Family Name (English)"
          control={control}
          errors={errors}
          disabled={view}
          required={true}
          size="sm"
          rules={{
            required: true,
            validate: (v) => isEnglish(v) || "Must be English letters only",
          }}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="first_name_arabic"
          label="First Name (Arabic)"
          placeholder="First Name (Arabic)"
          control={control}
          errors={errors}
          disabled={view}
          required={false}
          size="sm"
          rules={{
            validate: (v) => !v || isArabic(v) || "Must be Arabic letters only",
          }}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="father_name_arabic"
          label="Father Name (Arabic)"
          placeholder="Father Name (Arabic)"
          control={control}
          errors={errors}
          disabled={view}
          required={false}
          size="sm"
          rules={{
            validate: (v) => !v || isArabic(v) || "Must be Arabic letters only",
          }}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="family_name_arabic"
          label="Family Name (Arabic)"
          placeholder="Family Name (Arabic)"
          control={control}
          errors={errors}
          disabled={view}
          required={false}
          size="sm"
          rules={{
            validate: (v) => !v || isArabic(v) || "Must be Arabic letters only",
          }}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="email"
          control={control}
          label="Email "
          type="email"
          placeholder="Email "
          errors={errors}
          disabled={view}
          required={true}
          size="sm"
          rules={{
            required: true,
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "Invalid email address",
            },
          }}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <label className="form-label mb-2">
          Nationality <span className="text-danger">*</span>
        </label>
        <Controller
          name="nationality"
          control={control}
          rules={{ required: true }}
          disabled={view}
          render={({ field }) => (
            <MultiSelect
              {...field}
              menuPlacement="auto"
              closeMenuOnSelect={false}
              disabled={view}
              isMulti={false}
              options={nationalityData?.map((item) => ({
                value: item.value,
                label: item.title,
              }))}
              isClearable={true}
              value={
                field.value
                  ? {
                      value: field.value.value,
                      label: field.value.title,
                    }
                  : null
              }
              className={classNames({
                "is-invalid":
                  errors.nationality || (isSubmitted && !watch("nationality")),
              })}
              onChange={(selected) => {
                setValue(
                  "nationality",
                  selected
                    ? {
                        value: selected.value,
                        title: selected.label,
                      }
                    : null
                );
                clearErrors("nationality");
              }}
              formatOptionLabel={({ label }) => <div>{label}</div>}
              getOptionValue={(option) => option.value}
              placeholder="Choose ..."
            />
          )}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="mobile_no"
          label="Mobile No."
          control={control}
          placeholder="05xxxxxxxx"
          disabled={view}
          size="sm"
          errors={errors}
          rules={{
            validate: (v) =>
              !v ||
              /^05\d{8}$/.test(v) ||
              "Mobile number must start with 05 and be 10 digits",
          }}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="national_id"
          label="National ID"
          placeholder="National ID"
          control={control}
          size="sm"
          errors={errors}
          required={true}
          disabled={view}
          rules={{
            required: true,
            validate: (val) => {
              const nationality = watch("nationality");
              const id = String(val || "").trim();
              if (!/^\d{10}$/.test(id)) return "National ID must be 10 digits";

              if (nationality?.code === "SAU" || nationality?.value === "SAU") {
                return id.startsWith("1") ? true : "Saudi ID must start with 1";
              } else {
                return !id.startsWith("1")
                  ? true
                  : "Non-Saudi ID must not start with 1";
              }
            },
          }}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <BootDatePicker
          name="birth_date"
          label="Birth Date"
          control={control}
          disabled={view}
          size="sm"
          selected={watch("birth_date")}
          onChange={(date) => setValue("birth_date", date)}
          errors={errors}
          maxDate={new Date()}
          isRequired={false}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <label className="form-label">
          Branches <span className="text-danger">*</span>
        </label>
        <Controller
          name="branch"
          control={control}
          rules={{
            required: true,
          }}
          render={({ field }) => (
            <MultiSelect
              {...field}
              isMulti
              disabled={view}
              options={allBranchesData.map((b) => ({
                value: b.branch_id,
                label: b.branch_name,
                cchi: b.branch_cchino,
              }))}
              value={watch("branch")}
              onChange={(val) => {
                setValue("branch", val);
                clearErrors("branch");
              }}
              className={classNames({
                "is-invalid": errors.branch,
              })}
              placeholder="Choose branches..."
            />
          )}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <label className="form-label mb-2">
          System Privilage <span className="text-danger">*</span>
        </label>
        <Controller
          name="system_privilage"
          control={control}
          disabled={view}
          size="sm"
          rules={{
            required: true,
          }}
          render={({ field }) => (
            <MultiSelect
              {...field}
              menuPlacement="auto"
              closeMenuOnSelect={false}
              isMulti={false}
              options={systemPrivillageList?.map((item) => ({
                value: item.syspri_id,
                label: item.syspri_name,
              }))}
              isClearable={true}
              className={classNames({
                "is-invalid":
                  errors.system_privilage ||
                  (isSubmitted && !watch("system_privilage")),
              })}
              value={
                field.value
                  ? {
                      value: field.value.syspri_id,
                      label: field.value.syspri_name,
                    }
                  : null
              }
              onChange={(selected) => {
                setValue(
                  "system_privilage",
                  selected
                    ? {
                        syspri_id: selected.value,
                        syspri_name: selected.label,
                      }
                    : null
                );
                clearErrors("system_privilage");
              }}
              placeholder="Choose ..."
            />
          )}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="username"
          label="Username"
          placeholder="Username"
          control={control}
          errors={errors}
          disabled={view}
          required={true}
          size="sm"
          rules={{
            required: true,
          }}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="password"
          control={control}
          label="Password"
          size="sm"
          type="password"
          errors={errors}
          disabled={view}
          required={!id}
          placeholder="Password"
          rules={{
            required: !id,
            minLength: {
              value: 8,
              message: "Password must be at least 8 characters long",
            },
          }}
        />
      </Col>
    </Row>
  );
};

export default AddEmpolyeeForm;
